import(/* webpackMode: "eager", webpackExports: ["PageComponent"] */ "/vercel/path0/app/anmeldung/[eventId]/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/vercel/path0/app/layout-component.tsx");
